import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminPartners() {
  return (
    <AdminCrud
      title="Parceiros"
      resource="partners"
      initialItem={{ status: "published", order: 0 }}
      fields={[
        { name: "name", label: "Nome", required: true },
        { name: "logo_url", label: "Logotipo do parceiro", type: "image" },
        { name: "description", label: "Descrição" },
        { name: "link", label: "Link" },
        { name: "order", label: "Ordem", type: "number" },
      ]}
      columns={[
        { name: "name", label: "Nome" },
        { name: "link", label: "Link" },
      ]}
    />
  );
}
